import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../../assets/color-helpers.scss';
import { styles as styleHelpersStyles } from '../../../../assets/style-helpers.scss';
import { styles as flexboxHelpersStyles } from '../../../../assets/flexbox-helpers.scss';
import { styles as textHelpersStyles } from '../../../../assets/text-helpers.scss';
import { LabelWidthValues } from '../../../../types/common/types';
import { InputWidthValues } from '../../../../ui/gzInput';

export const templatePackageGeneralForm = document.createElement('template');

templatePackageGeneralForm.innerHTML = `
  <style>${colorHelpersStyles}</style>
  <style>${styleHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div id='package-general-form-wrapper'>
    <div class='form-section'>
      <gz-form-field id='package-name-form-field' class='label-mw-250' label='' required>
      <gz-input gz-form-input placeholder='' inputWidth='${InputWidthValues.LARGE}'></gz-input>
      <gz-input-error></gz-input-error>
    </gz-form-field>

    <gz-form-field id='package-description-form-field' class='label-mw-250' label=''>
      <gz-input gz-form-input placeholder='' inputWidth='${InputWidthValues.LARGE}'></gz-input>
      <gz-input-error></gz-input-error>
    </gz-form-field>

    <gz-form-field id='language-form-field' class='label-mw-250' label=''>
      <gz-dropdown gz-form-input localFiltering combobox type='dropdown'></gz-dropdown>
      <gz-input-error></gz-input-error>
    </gz-form-field>

    <gz-form-field id='company-form-field' class='label-mw-250' label='' required>
      <gz-single-select-complex gz-form-input labelWidth='${LabelWidthValues.LARGE}'></gz-single-select-complex>
      <gz-input-error></gz-input-error>
    </gz-form-field>
    </div>
  </div>
`;
